import React from "react";
import { ValidationWorkflowPanel } from "@/components/authority/KarateAuthorityDocumentsPanels.jsx";

export function DocumentsPreuvesValidationPage() {
  return (
    <div data-testid="page-admin-documents-preuves-validation">
      <ValidationWorkflowPanel testId="documents-preuves-validation-panel" />
    </div>
  );
}
